import "./ExternalFrame.scss";

const ExternalFrame = (params) => {
    const frameUrl = params.frameUrl?? false;
    const background = params.background?? "transparent";

    if(!frameUrl){
        return (
            <div className="external-frame">
                <h1>DEVELOPER ERROR</h1>
                <p>Developer error: No frame URL provided.</p>
            </div>
        )
    }

    return (
        <div className={"external-frame background"} data-bg-color={background}>
            <iframe src={frameUrl} title="External Frame" />
        </div>
    );
}

export default ExternalFrame;